import { environment } from '../environments/environment';

export class APIRoutes {
    private static api(path: string): string {
        return `${environment.apiBaseUrl}${path}`;
    }

    // Auth API
    public static AUTH_TOKEN_URI = APIRoutes.api('/book-now/v1/auth/login');
    public static SEND_OTP_URI = APIRoutes.api('/book-now/v1/otp/send');
    public static VALIDATE_OTP_URI = APIRoutes.api('/book-now/v1/otp/validate');
    public static CREATE_EXTERNAL_USER_URI = APIRoutes.api('/book-now/v1/user/external');
    public static RESET_PASSWORD_URI = APIRoutes.api('/book-now/v1/user/reset/password');
    public static USER_ACTIVATION_URI = APIRoutes.api('/book-now/v1/user/activate');
    public static EMAIL_PASSWORD_RESET_LINK_URI = APIRoutes.api('/book-now/v1/user/email/password-reset');
    public static FACILITY_TYPE_URI = APIRoutes.api('/book-now/v1/tenant-categories');
    public static SOCIAL_AUTH_TOKEN_URI = APIRoutes.api('/book-now/v1/auth/social-login')

    // Tenant
    public static CREATE_TENANT_V2_URI = APIRoutes.api('/book-now/v2/tenant');
    public static GET_TENANT_DETAIS_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/');
    public static UPDATE_TENANT_DETAILS_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant');
    public static UPDATE_TENANT_STATUS_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/status/');
    public static UPDATE_GOOGLE_MAPS_LINK_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/google-maps-link/');
    public static CREATE_TENANT_IMAGES = APIRoutes.api('/book-now/v1/tenant-images');
    public static GET_TENANT_IMAGES_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant-images/');
    public static UPDATE_TENANT_IMAGES_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant-images/');
    public static GET_TENANT_FEES = APIRoutes.api('/book-now/v1/tenant/fee');


    // Amenities
    public static GET_TENANT_AMENITIES_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/amenities');
    public static CREATE_TENANT_AMENITY = APIRoutes.api('/book-now/v1/tenant/amenities');
    public static DELETE_TENANT_AMENITY = APIRoutes.api('/book-now/v1/tenant/amenities');

    // Holiday
    public static CREATE_TENANT_HOLIDAY_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/holiday');
    public static GET_TENANT_HOLIDAYS_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/holidays');
    public static DELETE_TENANT_HOLIDAY_BY_HOLIDAYID = APIRoutes.api('/book-now/v1/tenant/holidays');

    // Rules
    public static CREATE_TENANT_RULE_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/rule');
    public static UPDATE_TENANT_RULE_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/rule');
    public static DELETE_TENANT_RULE_BY_RULEID = APIRoutes.api('/book-now/v1/tenant/rules');

    public static GET_TENANT_RULES_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/rules');

    // Service Types
    public static GET_ALL_SERVICE_TYPES = APIRoutes.api('/book-now/v1/service-types');

    // Product
    public static CREATE_PRODUCT = APIRoutes.api('/book-now/v1/tenant/product');
    public static UPDATE_PRODUCT = APIRoutes.api('/book-now/v1/tenant/product/');
    public static GET_ALL_PRODUCTS_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/products/');
    // POST UPLOAD_PRODUCT_IMAGE + productId + '/image' (multipart field "image")
    public static UPLOAD_PRODUCT_IMAGE = APIRoutes.api('/book-now/v1/tenant/product/');

    // Session
    public static CREATE_SESSION = APIRoutes.api('/book-now/v1/tenant/session');
    public static DELETE_SESSION = APIRoutes.api('/book-now/v1/tenant/session/');

    // Venue
    public static CREATE_VENUE = APIRoutes.api('/book-now/v1/tenant/venue');
    public static UPDATE_VENUE = APIRoutes.api('/book-now/v1/tenant/venue/');
    public static GET_ALL_VENUES_BY_TENANTID = APIRoutes.api('/book-now/v1/tenant/venues/');

    // Time Slot Wise Products
        public static CREATE_TIME_SLOT_WISE_PRODUCTS_BY_PRODUCTID = APIRoutes.api('/book-now/v1/time-slot-wise-products/product/');
        public static CREATE_TIME_SLOT_WISE_PRODUCTS = APIRoutes.api('/book-now/v1/time-slot-wise-products');

    // Saudagar
    // Tenant images by ID
    public static TENANT_IMAGES = APIRoutes.api('/book-now/v1/tenant-images'); // add param tenant id
    public static TENANT_AMENITIES = APIRoutes.api('/book-now/v1/tenant/amenities'); // add param tenant id

    public static ROUTING_MODULE_PRODUCT_ALL = APIRoutes.api('/book-now/v1/tenants');
    public static ROUTING_MODULE_PRODUCT_SINGLE = APIRoutes.api('/book-now/v1/tenant');

    public static SINGLE_BOOKING_REQUEST = APIRoutes.api('/book-now/v1/single/booking');
    public static ALL_SLOTS_OF_TENANT_SINGLE = APIRoutes.api('/book-now/v1/single/bookings');
    public static ALL_SLOTS_OF_TENANT_MULTI = APIRoutes.api('/book-now/v1/multi/session/bookings');
    public static SINGLE_SESSION_BOOKING_SLOTS = APIRoutes.api('/book-now/v1/single-session/bookings/');
    public static MULTI_SESSION_BOOKING_SLOTS = APIRoutes.api('/book-now/v1/multi-session/bookings/');

    public static INITIATE_TRANSACTION = APIRoutes.api('/book-now/v1/initiate-transaction');
    public static INITIATE_PHONEPAY_PAY_API = APIRoutes.api('/book-now/v1/initiate/phonepe/pay/api');
    public static GET_ALL_TRANSACTIONS = APIRoutes.api('/book-now/v1/transactions');
    public static GET_DASHBOARD_REVENUE = APIRoutes.api('/book-now/v1/dashboard/revenue');
    public static GET_DASHBOARD_WORKLISTS = APIRoutes.api('/book-now/v1/dashboard/worklists');
    public static GET_REPORT = APIRoutes.api('/book-now/v1/report');
    public static GET_ALL_USERS = APIRoutes.api('/book-now/v1/users');
    public static GET_USER = APIRoutes.api('/book-now/v1/user');
    public static SERVICE_ENQUIRY = APIRoutes.api('/book-now/v1/service-enquiry');
    public static UPDATE_USER = APIRoutes.api('/book-now/v1/user');
    public static GET_USER_TRANSACTIONS = APIRoutes.api('/book-now/v1/user/transactions');
    public static CONFIRM_BOOKING = APIRoutes.api('/book-now/v1/booking');
    public static GET_BOOKING_BY_ID = APIRoutes.api('/book-now/v1/booking/');
    public static CANCEL_BOOKING = APIRoutes.api('/book-now/v1/booking/cancel/');
    public static MARK_BOOKING_PAID = APIRoutes.api('/book-now/v1/booking/mark-paid/');
    public static CANCEL_SLOT = APIRoutes.api("/book-now/v1/booking-slots/cancel")

    public static GET_CONFIG = APIRoutes.api("/book-now/v1/config/")
    public static UPDATE_CONFIG = APIRoutes.api("/book-now/v1/config")


    public static INITIATE_BILLDESK_PAYMENT = APIRoutes.api("/book-now/v1/initiate/billdesk/pay");
    public static INITIATE_BILLDESK_PAYMENT_LINK = APIRoutes.api("/book-now/v1/initiate/billdesk/pay-link/");
    public static UPDATE_BILLDESK_PAYMENT_STATUS = APIRoutes.api("/book-now/v1/billdesk/transaction/status");
}

